import { format } from 'date-fns';
import { FC } from 'react';

import { useEventContext } from '../../../hooks/contexts/event.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import useFormattedDateTimeZone from '../../../hooks/useFormattedDateTimeZone';
import { TicketDate } from '../../../types/ticket';
import * as Styles from './styles.timelineDate';

type AsideTimelineDateProps = {
  isLastItem: boolean;
  id: string;
  eventDate: TicketDate;
};

const AsideTimelineDate: FC<AsideTimelineDateProps> = ({ isLastItem, id,eventDate }) => {
  const { currentLocale : { locale : l }, supportedLocales } = useI18nContext();
  const { event } = useEventContext();
  const { formatDate } = useFormattedDateTimeZone();

  function formatEventDate(eventDate: TicketDate) {
    const { datetime } = eventDate;
    const locale = supportedLocales({ lang : l });

    const adjustedDate = formatDate(datetime, event?.timezone ?? 'America/Sao_Paulo');
    const dayWeek = format(adjustedDate, 'EEE', { locale });
    const dayMonth = format(adjustedDate, 'dd', { locale });
    const month = format(adjustedDate, 'MMM', { locale });
    const hour = format(adjustedDate, 'HH\':\'mm', { locale });

    return { dayWeek, dayMonth, month, hour };
  }

  const { dayWeek, dayMonth, month, hour } = formatEventDate(eventDate);

  return (
    <Styles.WrapperTimelineDate id={`timeline-date-wrapper-${id}`}>

      <Styles.WrapperDate id={`timeline-date-${id}`}>
        <Styles.Weekday id={`timeline-weekday-${id}`}>{dayWeek.substring(0, 3)}</Styles.Weekday>
        <Styles.Division />
        <Styles.ContainerDate id={`timeline-container-date-${id}`}>
          <Styles.Day id={`timeline-day-${id}`}>{dayMonth}</Styles.Day>
          <Styles.Month id={`timeline-month-${id}`}>{month}</Styles.Month>
        </Styles.ContainerDate>
        <Styles.Division />
        <Styles.Hour id={`timeline-hour-${id}`}>{hour}</Styles.Hour>
      </Styles.WrapperDate>

      <Styles.VerticalLine $isLastItem={isLastItem} id={`timeline-vertical-line-${id}`} />

    </Styles.WrapperTimelineDate>
  );
};

export default AsideTimelineDate;
